<template>
  <div class="row">
    <div class="col-5">
    </div>
    <div class="col-2" :hidden="isLoggedIn">
      <div class="card">
        <div class="card-header">
          <label>
            <h2>
              Login to Portal
            </h2>
          </label>
        </div>
        <form class="card-body">
          <label for=""><h4>User Name</h4></label>
          <input type="text" class="form-control" v-model="userName">
          <br>
          <label for=""><h4>Password</h4></label>
          <input type="password" class="form-control" v-model="password">
          <br>
          <button class="btn btn-primary" v-on:click.prevent="initializeData">Login</button>
        </form>
      </div>
    </div>
    <div class="col-2" :hidden="!isLoggedIn">
      <div class="card">
        <div class="card-body">
          <div class="row" v-if="areResourcesLoaded">
            <select class="custom-select mr-sm-1" name="" v-model="selectedFolder" v-on:change="setServices">
              <option value="0" selected disabled>Folders</option>
              <option v-for="(folderItem, index) in folders" :key="index" :value="folderItem">{{folderItem}}</option>
            </select>
            <br>
            <select class="custom-select mr-sm-1" name="" v-model="selectedService" v-on:change="setLayers" :disabled="services.length>0?false:true">
              <option value="0" selected disabled>{{noServices}}</option>
              <option v-for="(servicesItem, index) in services" :key="index" :value="servicesItem">{{servicesItem}}</option>
            </select>
            <br>
            <select class="custom-select mr-sm-1" name="" v-model="selectedLayer" :disabled="layers.length>0?false:true">
              <option value="0" selected disabled>{{noLayers}}</option>
              <option v-for="(layerItem, index) in layers" :key="index" :value="layerItem">{{layerItem}}</option>
            </select>
          </div>
          <br>
          <div class="row">
            <div class="col-6">
              <button class="btn btn-outline-primary" v-on:click="generateShapeFile" :disabled="selectedLayer==0?true:false">Generate ShapeFile</button>
            </div>
            <div class="col-6">
              <button class="btn btn-outline-danger" v-on:click.prevent="accountLogout">Logout</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-2">
      <b-alert variant="danger" v-model="showErrorMessage">
        {{errorMessage}}
      </b-alert>
      <b-alert variant="success" v-model="showSuccessMessage">
        {{successMessage}}
      </b-alert>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import Qs from 'qs'
import {redirectURL, mapURL} from "../../config.js"
var shpwrite = require('shp-write');

export default {
  name: "Map",
  data() {
    return {
      isLoggedIn: false,
      userName: "",
      password: "",
      accessToken: "",
      errorMessage: "",
      showErrorMessage: false,
      successMessage: "",
      showSuccessMessage: false,
      folders: [],
      selectedFolder: "0",
      areResourcesLoaded: false,
      services: [],
      selectedService: "0",
      noServices: "Services",
      noLayers: "Layers",
      selectedLayer: "0",
      layers: []
    }
  },
  methods: {
    initializeData: function() {
      const current = this
      if (current.userName && current.password) {
        current.accountLogin(current).then(data=>{
          current.accessToken = data.token // token needs to be a request body item
          current.getFolders(current).then(folders=>{
            folders.forEach(folder=>{
              current.folders.push(folder)
            })
            current.areResourcesLoaded = true
          })
        }).catch(accountLoginError=>{
          current.errorMessage = accountLoginError + " Please enter the correct username and password to continue"
          current.showErrorMessage = true
          setTimeout(function() {
            current.showErrorMessage = false
            current.errorMessage = ""
          },2500);
        })
      }
      else {
        alert("Please enter both username and password to access Portal data")
      }
    },
    accountLogin: function(current) {
      return new Promise(function(resolve, reject) {
        var params = {
          username: current.userName,
          password: current.password,
          client: "referer",
          referer: redirectURL, // should be replaced by state-specific url (dev vs live production)
          f: "json"
        }
        var tokenConfig = {
          url: mapURL.generateToken,
          method: "POST",
          data: Qs.stringify(params),
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          withCredentials: true
        }

        axios(tokenConfig).then(result=>{
          console.log(result);
          if (typeof result.data.error == "undefined") {
            current.isLoggedIn = true
            resolve(result.data)
          }
          else {
            reject(result.data.error.message)
          }
        })
      });
    },
    getFolders: function(current) {
      return new Promise(function(resolve, reject) {
        var folderConfig  = {
          url: mapURL.services,
          method: "POST",
          data: Qs.stringify({
            token: current.accessToken,
            f: "json"
          }),
          header: {
            'content-type': 'application/x-www-form-urlencoded'
          }
        }
        axios(folderConfig).then(result=>{
          if (typeof result.data.error == "undefined") {
            console.log(result.data);
            resolve(result.data.folders)
          }
          else{
            reject(result.data.error.message)
          }
        })
      })
    },
    setServices: function() {
      const current = this
      current.services = []
      current.selectedService = "0"
      current.layers = []
      current.selectedLayer = "0"
      var serviceConfig  = {
        url: mapURL.services+ "/" + current.selectedFolder,
        method: "POST",
        data: Qs.stringify({
          token: current.accessToken,
          f: "json"
        }),
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }
      axios(serviceConfig).then(result=>{
        console.log(result.data.services);
        var services = result.data.services.filter(obj=>obj.type == "FeatureServer")
        if(services.length > 0){
          current.noServices ="Services"
          services.forEach(service=>{
            current.services.push(service.name)
          })
        }
        else {
          current.noServices ="No Services Available"
        }
      })
    },
    setLayers: function() {
      const current = this
      current.layers = []
      current.selectedLayer = "0"
      var layerURL = mapURL.services + "/" + current.selectedService + "/MapServer"
      console.log(layerURL);
      var layerConfig  = {
        url:  layerURL,
        method: "POST",
        data: Qs.stringify({
          token: current.accessToken,
          f: "json"
        }),
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }
      axios(layerConfig).then(result=>{
        console.log(result.data.layers);
        if(result.data.layers.length > 0){
          current.noLayers ="Layers"
          result.data.layers.forEach(layer=>{
            current.layers.push(layer.name)
          })
        }
        else {
          current.noLayers ="No Layers Available"
        }
      })
    },
    accountLogout: function() {
      const current = this
      current.userName = ""
      current.password = ""
      current.isLoggedIn = false
      current.areResourcesLoaded = false
      current.folders = []
      current.selectedFolder = "0"
      current.services = []
      current.selectedService = "0"
      current.selectedLayer = "0"
      current.layers = []
    },
    setDataFeatures: function(current) {
      return new Promise(function(resolve, reject) {
        var dataLayerURL = mapURL.services + "/" + current.selectedService + "/FeatureServer/0/query"
        console.log(dataLayerURL);
        var dataLayerConfig = {
          url: dataLayerURL,
          method: "POST",
          data: Qs.stringify({
            token: current.accessToken,
            f: "geojson",
            where: "1=1",
            outFields: "*",
            outSR: 4326
          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          }
        }
        axios(dataLayerConfig).then(result=>{
          if (typeof result.data.error == "undefined") {
            resolve(result.data)
          }
          else{
            reject(result.data.error.message)
          }
        })
      })
    },
    generateShapeFile: function() {
      const current = this
      current.setDataFeatures(current).then(features=>{
        console.log(features);
        var options = {
          types: {
            point: 'mypoints',
            polygon: 'mypolygons',
            line: 'mylines'
          }
        }
        shpwrite.download(features, options)
      })

    }
  }
}
</script>

<style lang="css" scoped>
</style>
